module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loaded) ? _c('loading-icon', {
    staticClass: "c-card c-card--claims-list"
  }) : _c('section', {
    staticClass: "c-card c-card--claims-list"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('i', {
    staticClass: "c-card__header__icon fa fa-inbox t-headline"
  })]), _vm._v(" "), (_vm.approverClaims.length == 0) ? [_c('div', {
    staticClass: "c-card__body t-text-color"
  }, [_c('div', {
    staticClass: "c-card--claims-list__empty"
  }, [_c('i', {
    staticClass: "c-card--claims-list__empty__icon fa fa-thumbs-up"
  }), _vm._v(" "), _c('p', {
    staticClass: "c-card--claims-list__empty__text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_approver.no_claims_to_approve')) + "\n        ")])])])] : _vm._e(), _vm._v(" "), (_vm.approverClaims.length > 0) ? [_c('div', {
    staticClass: "c-card__body c-card--claims-list__body"
  }, [_c('transition', {
    attrs: {
      "name": "fade-and-slide"
    }
  }, [(_vm.claimModalMessage !== null && _vm.claimModalType == 'approver') ? _c('div', {
    ref: "claimToast",
    staticClass: "c-toast t-toast-success"
  }, [_c('p', {
    staticClass: "c-toast__text"
  }, [_vm._v(_vm._s(_vm.claimModalMessage))])]) : _vm._e()]), _vm._v(" "), _c('section', [(_vm.pendingForThisPage.length > 0) ? _c('h2', {
    staticClass: "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_approver.pending_claims')) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pendingForThisPage), function(claim) {
    return _c('div', {
      key: claim.id,
      staticClass: "c-card--claims-list__claim",
      on: {
        "click": function($event) {
          return _vm.showClaim(claim.id)
        }
      }
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info"
    }, [_c('h3', {
      staticClass: "c-card--claims-list__claim__info__pax"
    }, [_vm._v(_vm._s(claim.participant_name))]), _vm._v(" "), _c('div', {
      staticClass: "c-card--claims-list__claim__info__details"
    }, [_c('span', {
      staticClass: "c-card--claims-list__claim__info__details__date"
    }, [_vm._v(_vm._s(claim.created_at))]), _vm._v(" "), _c('span', {
      staticClass: "c-card--claims-list__claim__info__details__form"
    }, [_vm._v(_vm._s(claim.form_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "c-approvals__claim__status"
    }, [_c('button', {
      staticClass: "c-status",
      class: _vm.claimStatusClass(claim)
    }, [_vm._v("\n              " + _vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[claim.status])) + "\n            ")])])])
  })], 2), _vm._v(" "), _c('section', [((_vm.notPendingForThisPage.length > 0) && (_vm.pendingForThisPage.length > 0)) ? _c('h2', {
    staticClass: "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_claims_approver.other_claims')) + "\n        ")]) : _c('div', {
    staticClass: "u-margin-top-15"
  }), _vm._v(" "), _vm._l((_vm.notPendingForThisPage), function(claim) {
    return _c('div', {
      key: claim.id,
      staticClass: "c-card--claims-list__claim",
      on: {
        "click": function($event) {
          return _vm.showClaim(claim.id)
        }
      }
    }, [_c('div', {
      staticClass: "c-card--claims-list__claim__info"
    }, [_c('h3', {
      staticClass: "c-card--claims-list__claim__info__pax"
    }, [_vm._v(_vm._s(claim.participant_name))]), _vm._v(" "), _c('div', {
      staticClass: "c-card--claims-list__claim__info__details"
    }, [_c('span', {
      staticClass: "c-card--claims-list__claim__info__details__date"
    }, [_vm._v(_vm._s(claim.created_at))]), _vm._v(" "), _c('span', {
      staticClass: "c-card--claims-list__claim__info__details__form"
    }, [_vm._v(_vm._s(claim.form_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "c-approvals__claim__status"
    }, [_c('button', {
      staticClass: "c-status",
      class: _vm.claimStatusClass(claim)
    }, [_vm._v("\n              " + _vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[claim.status])) + "\n            ")])])])
  })], 2)], 1)] : _vm._e(), _vm._v(" "), _c('paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.setPage
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-708ce4be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/ClaimsApprover.vue
// module id = 551
// module chunks = 1